import { render, staticRenderFns } from "./CharacteristicValue.vue?vue&type=template&id=300dde04&"
import script from "./CharacteristicValue.vue?vue&type=script&lang=js&"
export * from "./CharacteristicValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports